export default __webpack_public_path__ + "static/media/missionImg.3c8bbe53.png";